import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, FormGroup, Label, Input, Modal } from "reactstrap";
import {
  commonPageFieldList,
  commonPageFieldListSuccess,
} from "../../../store/actions";
import { C_DatePicker, C_Select } from "../../../CustomValidateForm";
import { Go_Button, PageLoadingSpinner } from "../../../components/Common/CommonButton";
import { mode, pageId, url } from "../../../routes/index";
import {
  deleteNocList_Id,
  deleteNocList_Id_Success,
  filterNocDocument,
  filterNocDocumentSuccess
} from "../../../store/Administrator/UploadNocRedux/action";
import { GetVenderSupplierCustomer, GetVenderSupplierCustomerSuccess } from "../../../store/actions";
import CommonPurchaseList from "../../../components/Common/CommonPurchaseList";
import NocDocumentUpload from "./NocNdcDocument";
import { initialFiledFunc } from "../../../components/Common/validationFunction";
import SERVER_HOST_PATH from "../../../helpers/_serverPath";
import Slidewithcaption from "../../../components/Common/CommonImageComponent";
import * as _cfunc from "../../../components/Common/CommonFunction";

const NocListPage = () => {
  const dispatch = useDispatch();
  const fields = {
    Supplier: "",
  };

  const [state, setState] = useState(() => initialFiledFunc(fields));
  const [imageTable, setImageTable] = useState([]);
  const [isShowClicked, setIsShowClicked] = useState(false);
  const [modal_backdrop, setModalBackdrop] = useState(false);
  const [hederFilters, setHederFilters] = useState({ fromdate: _cfunc.currentDate_ymd, todate: _cfunc.currentDate_ymd });
  const { fromdate, todate, } = hederFilters;
  const [selectedSupplier, setSelectedSupplier] = useState({ value: 0, label: "All" });

  const reducers = useSelector((state) => ({
    tableList: state.UploadNocReducer.filterResult,
    listBtnLoading: state.UploadNocReducer.filterLoading,
    userAccess: state.Login.RoleAccessUpdateData,
    pageField: state.CommonPageFieldReducer.pageFieldList,
    supplier: state.CommonAPI_Reducer.vendorSupplierCustomer || [],
    supplierDropLoading: state.CommonAPI_Reducer.vendorSupplierCustomerLoading,
    commonPartyDropSelect: state.CommonPartyDropdownReducer.commonPartyDropSelect,
    monthYearLabel: state.UploadNocReducer.Month,
    deleteMsg: state.UploadNocReducer.deleteMsg,
  }));

  const {
    listBtnLoading,
    pageField,
    supplier,
    supplierDropLoading,
    commonPartyDropSelect,
    monthYearLabel,
    deleteMsg,
  } = reducers;

  useEffect(() => {
    dispatch(commonPageFieldListSuccess(null));
    dispatch(commonPageFieldList(pageId.NOC_LIST_PAGE));
  }, [dispatch]);

  useEffect(() => {
    if (commonPartyDropSelect?.value > 0) {
      dispatch(GetVenderSupplierCustomer({
        subPageMode: url.NOC_DOCUMENT_UPLOAD,
        PartyID: commonPartyDropSelect.value,
      }));
      setSelectedSupplier({ value: 0, label: "All" });
    } else {
      dispatch(GetVenderSupplierCustomerSuccess([]));
      setSelectedSupplier(null);
    }
  }, [commonPartyDropSelect, dispatch]);

  const action = {
    deleteId: deleteNocList_Id,
    deleteSucc: deleteNocList_Id_Success
  };

  const tog_backdrop = () => {
    setModalBackdrop(!modal_backdrop);
    if (modal_backdrop) {
      setImageTable([]);
      setIsShowClicked(false);
    }
  };

  const supplierOptions = Array.isArray(supplier)
    ? [{ value: 0, label: "All" }, ...supplier.map(i => ({
      value: i.id,
      label: i.Name,
    }))]
    : [];


  const goButtonHandler = () => {
    const payload = {
      Supplier: selectedSupplier?.value || 0,
      PartyID: commonPartyDropSelect?.value || 0,
      FromDate: fromdate,
      ToDate: todate,
    };

    dispatch(filterNocDocument(payload));
  };

  function downBtnFunc(data) {
    const rowData = data?.rowData;

    if (!rowData || !rowData.FilePath) {
      return;
    }

    const cleanedPath = rowData.FilePath.replace(/\\/g, "/").trim();
    const fileExtension = cleanedPath.split('.').pop().toLowerCase();

    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

    const downloadUrl = `${SERVER_HOST_PATH}/filedownloadusingpath/?file_path=${cleanedPath}`;

    if (imageExtensions.includes(fileExtension)) {
      const fullUrl = cleanedPath.startsWith("http")
        ? cleanedPath
        : `${SERVER_HOST_PATH}/media/${cleanedPath}`;


      setImageTable([{ Image: fullUrl, DownloadURL: downloadUrl }]);

      setModalBackdrop(true);
    } else if (fileExtension === 'pdf') {
      const fullUrl = cleanedPath.startsWith("http")
        ? cleanedPath
        : `${SERVER_HOST_PATH}/media/${cleanedPath}`;
      window.open(fullUrl, '_blank');
    } else {
      console.warn("Unsupported file extension:", fileExtension);
    }
  }

  const downloadFile = async (url) => {
    const response = await fetch(url, {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem(`${_cfunc.GET_COMPANY_FROM_URL()}_token`)}`
      }
    });

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = url.split("/").pop();
    link.click();
  };

  function fromdateOnchange(e, date) {
    setHederFilters(prev => {
      let newToDate = prev.todate;

      // ✅ Only fix ToDate if it becomes invalid
      if (new Date(prev.todate) < new Date(date)) {
        newToDate = date;
      }

      return {
        ...prev,
        fromdate: date,
        todate: newToDate,   // ✅ only changes when required
      };
    });
  }

  function todateOnchange(e, date) {
    setHederFilters(prev => ({ ...prev, todate: date }));
  }


  const HeaderContent = () => (
    <div className="px-2 c_card_filter text-black">
      <div className="row">
        {/* From Date */}
        <Col sm="3">
          <FormGroup className="mb-2 row mt-3">
            <Label className="col-sm-5 p-2" style={{ width: "83px" }}>
              FromDate
            </Label>
            <Col sm="7">
              <C_DatePicker
                name="FromDate"
                value={fromdate}
                onChange={fromdateOnchange}
              />
            </Col>
          </FormGroup>
        </Col>

        <Col sm="3">
          <FormGroup className="mb-2 row mt-3">
            <Label className="col-sm-5 p-2" style={{ width: "65px" }}>
              ToDate
            </Label>
            <Col sm="7">
              <C_DatePicker
                name="ToDate"
                value={_cfunc.ToDate({ FromDate: fromdate, Todate: todate })}
                onChange={todateOnchange}
                options={{
                  minDate: _cfunc.disablePriviousTodate({ fromDate: fromdate }),
                  maxDate: "today",
                  altInput: true,
                  altFormat: "d-m-Y",
                  dateFormat: "Y-m-d",
                }}
              />

            </Col>
          </FormGroup>
        </Col>

        {/* Supplier Dropdown */}
        <Col sm="3">
          <FormGroup className="mb-2 row mt-3">
            <Label className="col-sm-5 p-2" style={{ width: "65px" }}>
              Supplier
            </Label>
            <Col lg="7">
              <C_Select
                name="Supplier"
                classNamePrefix="select2-Customer"
                value={selectedSupplier}
                options={supplierOptions}
                onChange={setSelectedSupplier}
                isLoading={supplierDropLoading}
                styles={{
                  container: (base) => ({ ...base, width: "150%" }),
                  menu: (p) => ({ ...p, zIndex: 3000 }),
                }}
              />
            </Col>
          </FormGroup>
        </Col>

        <Col sm="2" />

        {/* Go Button */}
        <Col sm="1" className="mt-3 mb-2">
          <Go_Button loading={listBtnLoading} onClick={goButtonHandler} />
        </Col>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <Modal
        isOpen={modal_backdrop}
        toggle={tog_backdrop}
        style={{ width: "800px", height: "800px", borderRadius: "0" }}
        className="modal-dialog-centered"
      >
        {/* --- Download Button (Top-Right Corner) --- */}
        {imageTable.length > 0 && (
          <button
            onClick={() => downloadFile(imageTable[0].DownloadURL)}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 9999,
              backgroundColor: "#fff",
              border: "none",
              cursor: "pointer",
              padding: "6px",
              borderRadius: "50%",
              boxShadow: "0 0 4px rgba(0,0,0,0.3)"
            }}
            title="Download"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
          </button>
        )}
        {/* --- CHANGE: Pass imageTable directly as Images prop */}
        {imageTable.length > 0 ? (
          <Slidewithcaption Images={imageTable} />
        ) : (
          <div style={{ padding: "20px", textAlign: "center" }}>
            <p>No image available</p>
          </div>
        )}
      </Modal>
      <PageLoadingSpinner isLoading={listBtnLoading || !pageField} />
      <div className="page-content">
        {pageField && (
          <CommonPurchaseList
            action={action}
            reducers={reducers}
            pageMode={mode.defaultList}
            downBtnFunc={downBtnFunc}
            showBreadcrumb={false}
            MasterModal={NocDocumentUpload}
            masterPath={url.NOC_DOCUMENT_UPLOAD}
            newBtnPath={url.NOC_DOCUMENT_UPLOAD}
            ButtonMsgLable={"NOC"}
            deleteName={"SupplierName"}
            HeaderContent={HeaderContent}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default NocListPage;
